<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left">
            <span class="mb-0 h3 ml-2">操作歷程記錄</span>
          </div>
        </template>
        <b-navbar toggleable="md">
          <b-navbar-nav>
            <b-nav-form inline class="mr-1">
              <label for="inline-form-input-name">管理者名稱：</label>
              <b-form-input
                id="inline-form-input-name"
                v-model="searchName"
                class="mr-2"
              ></b-form-input>
            </b-nav-form>
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-form inline>
              <label for="inline-form-input-datepicker">操作日期：</label>
              <b-form-datepicker
                id="inline-form-input-datepicker"
                v-model="serachDate"
                class="mr-2"
                label-no-date-selected="選擇日期"
                reset-button
                close-button
              ></b-form-datepicker>
            </b-nav-form>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-form class="py-2">
              <b-form-select v-model="each" size="sm">
                <b-form-select-option v-for="n in [10, 20, 30, 50]" :value="n" :key="n">每頁顯示筆數: {{ n }}</b-form-select-option>
              </b-form-select>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-table
          id="records-table"
          bordered
          show-empty
          empty-text="尚無資料"
          hover
          :items="items"
          :fields="fields"
          :busy="Boolean(isBusy)"
          responsive="md"
          class="mt-2"
          head-variant="light"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="mr-3 align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(time)="data">{{ data.value | DateFormatter }}</template>
          <template v-slot:cell(name)="data">{{ data.value | OpsFormatter }}</template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="each"
          aria-controls="user-table"
          class="float-right"
        ></b-pagination>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import moment from 'moment'
import { OpsRecords } from '../../library/Var.js'
export default {
  data () {
    return {
      currentPage: 1,
      each: 10,
      rows: 0,
      searchName: '',
      serachDate: '',
      isBusy: false,
      items: []
    }
  },
  computed: {
    fields () {
      return [{
        key: 'admin_name', label: '操作者名稱', tdClass: 'text-center'
      }, {
        key: 'time', label: '操作時間', tdClass: 'text-center'
      }, {
        key: 'name', label: '執行操作', tdClass: 'text-center'
      }]
    },
    postBody () {
      const obj = {
        page: this.currentPage,
        each: this.each
      }
      if (this.searchName) {
        obj.name = this.searchName
      }
      if (this.serachDate) {
        obj.date = this.serachDate
      }
      return obj
    }
  },
  methods: {
    start () {
      if (this.isBusy) {
        clearTimeout(this.isBusy)
      }
      this.isBusy = setTimeout(async () => {
        try {
          const { data, headers } = await this.$api.postOpsRecords(this.postBody)
          this.rows = Number.parseInt(headers['shop-options-count']) || 0
          this.items = data
        } catch (err) {
          console.log(err)
        }
        this.isBusy = false
      }, 2000)
    }
  },
  filters: {
    DateFormatter (time) {
      return moment(time).format('YYYY/MM/DD HH:mm:ss')
    },
    OpsFormatter (name) {
      return OpsRecords[name]
    }
  },
  mounted () {
    this.start()
  },
  watch: {
    postBody () {
      this.start()
    }
  }
}
</script>
<style>
  .b-calendar-inner .form-inline .form-control {
	width: 100%;
  }
</style>